/**
 * Email row subcomponent
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ChangeEmail from './ChangeEmail';
import messages from './messages';

function EmailRow({ user, onRequestSuccess }) {
  return (
    <>
      <dt>
        <FormattedMessage {...messages.email} />
      </dt>
      <dd className="mb-3">
        {user.email}
        <ChangeEmail user={user} onRequestSuccess={onRequestSuccess} />
      </dd>
    </>
  );
}

EmailRow.propTypes = {
  user: PropTypes.object.isRequired,
  onRequestSuccess: PropTypes.func.isRequired,
};

export default EmailRow;
